<template>
    <div class="card">
        <div class="card-header d-flex justify-content-between flex-column flex-md-row">
            <slot name="header">
                {{ __('Billing Addresses') }}
            </slot>

            <button
                class="btn btn-primary btn-sm my-md-auto mt-2 mt-md-0"
                @click="showModal = true"
            >
                {{ __('Add new billing address') }}
            </button>
        </div>

        <div class="card-body">
            <div class="card-columns">
                <transition-group
                    name="list-complete"
                    tag="div"
                >
                    <div
                        v-for="address in addressList"
                        :key="address.id"
                        :class="{ 'selected-address': value === address.id }"
                        class="card"
                        style="cursor: pointer"
                        @click="$emit('input', address.id)"
                    >
                        <address-item :address="address" />
                    </div>
                </transition-group>
            </div>
        </div>
        <CreateBillingAddressModal
            v-if="showModal"
            :countries="countries"
            @close="showModal = false"
            @created="addressCreated($event)"
        />
    </div>
</template>

<script>
import CreateBillingAddressModal from './CreateBillingAddressModal'

export default {
    name: 'BillingAddressSelector',
    components: { CreateBillingAddressModal },
    props: {
        addresses: {
            type: Array,
            default: () => []
        },
        countries: {
            type: Array,
            default: () => []
        },
        value: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            addressList: this.addresses,
            showModal: false,
        }
    },

    created() {
        this.$bus.$on('address-deleted', address => this.remove(address))
        if ( this.addresses.length && this.value === null) {
            this.$emit('input', this.addresses[0].id)
        }
    },

    methods: {
        remove(address) {
            let selectedAddress = this.addressList.find( (el) =>  el.id == address.id )

            if ( !selectedAddress ) return

            this.addressList.splice(this.addressList.findIndex( (el) =>  el == selectedAddress ), 1)

            if ( this.$parent.billingAddress !== address.id ) return

            this.$emit('input', null)
        },

        add(address) {
            this.addressList.splice(0, 0, address)
        },

        addressCreated(address) {
            this.add(address)

            this.showModal = false

            this.$emit('input', this.addresses[0].id)
        }
    },
}
</script>

<style scoped>
.selected-address {
  border: 1px solid blue;
}

.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}

/* .list-complete-leave-active below version 2.1.8 */
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}
</style>
